import React from 'react';

import { Badge, Tooltip } from 'antd';

import { useTranslation } from 'react-i18next';
import { concatName } from '../utils/utils';

import Logo from '../images/logo500.png';

import { Props as ContainerProps } from './HeaderEXTContainer';
import PrestadorPrescripcionData from '../layout/entities/PrestadorPrescripcionData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAdjust, faBell, faLock, faTimes, faUser, faUserLock } from '@fortawesome/free-solid-svg-icons';

import cx from 'classnames';

const AppHeaderGCO = (props: {
    onClickClose: () => void;
    onClickBlocked: () => void;
    onClickOtpAuthentication?: (reconfig?: boolean) => void;
    prestadorData?: PrestadorPrescripcionData;
    nPrescripcionesBloqueadas?: number;
    idCompaniaCosalud: number;
} & ContainerProps) => {

    const { t } = useTranslation(['header']);

    return (
        <div className='ext-header'>
            <div>
                <div className='logos-container'>
                    <div className='logo-cosalud'>
                        <img src={Logo} />
                    </div>
                </div>
            </div>
            <div>
                <div className='prestador'>
                    <div className='prestador--inner'>
                        {props.prestadorData && <div><b>{concatName(props.prestadorData.nameNombre, props.prestadorData.nameApellido1, props.prestadorData.nameApellido2)}</b></div>}
                        {props.prestadorData && <div>{`${props.prestadorData.especialidad}  #${props.prestadorData.numeroColegiado}`}</div>}
                    </div>
                </div>
                <div className={cx('info-bloqueo', {active: props.nPrescripcionesBloqueadas})} onMouseEnter={e => e.currentTarget.classList.add('stop-animation')} onClick={props.onClickBlocked}>
                    <Tooltip title={props.nPrescripcionesBloqueadas === 0 ? t('prescripcionesBloqueadas_zero') 
                        : t('prescripcionesBloqueadas', {count: props.nPrescripcionesBloqueadas})}>
                        <Badge count={props.nPrescripcionesBloqueadas} showZero>
                            <div className='icon-container'> <FontAwesomeIcon icon={faBell} /> </div>
                        </Badge>
                    </Tooltip>
                </div>
                <div className='header-options--container otp' style={{lineHeight: '0'}}>
                    <FontAwesomeIcon icon={faUserLock} className='header-options--option' onClick={() => props.onClickOtpAuthentication!(true)}/>
                </div>

                <div className='header-options--container' style={{lineHeight: '0'}}>
                    <FontAwesomeIcon icon={faTimes} className='header-options--option' onClick={props.onCloseSession}/>
                </div>
                
            </div>
        </div>
    );
}

export default AppHeaderGCO;